module.exports = __webpack_public_path__ + "img/mobilesystem1.ac099aba.png";